// ASP Tags
import A8netTag from 'asp/rental/A8net';
import MfroTag from 'asp/rental/Mfro';
import RentracksTag from 'asp/rental/Rentracks';
import SphereTag from 'asp/rental/Sphere';
import AffitownTag from 'asp/rental/Affitown';
import GoogleTag from 'asp/rental/Google';
import SlvrbulletTag from 'asp/rental/Slvrbullet';
import AffilicodeTag from 'asp/rental/Affilicode';
import AffilisTag from 'asp/rental/Affilis';
import MononofuTag from 'asp/rental/Mononofu';
import TownlifeTag from 'asp/rental/Townlife';
//import DapTag from 'asp/Dap';
import AccesstradeTag from 'asp/rental/Accesstrade';
import AdfactoryTag from 'asp/rental/Adfactory';

const AspTags = () => {
  return (
    <>
      <GoogleTag />
      <SlvrbulletTag />
      <AccesstradeTag />
      <AffilicodeTag />
      <A8netTag />
      <MfroTag />
      <RentracksTag />
      <SphereTag />
      <AffilisTag />
      <MononofuTag />
      <TownlifeTag />
      <AdfactoryTag />
      <AffitownTag />
      {/*<DapTag />*/}
    </>
  );
};
export default AspTags;
